<!-- 搜索在订的汽配件 -->
<template>
    <div class="searchAp-ctn">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input v-model="searchData.APCode" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input v-model="searchData.GoodName" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">汽配分类</div>
                    <div>
                        <el-select size="small" style="width: 120px" filterable clearable v-model="searchData.Cate" @visible-change="getGoodsType($event)">
                            <el-option label="全部" value></el-option>
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">品牌</div>
                    <div>
                        <el-select v-model="searchData.BrandName" filterable clearable size="small" style="width: 120px" @visible-change="getGoodsBrand($event)">
                            <el-option label="全部" value></el-option>
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">互换码</div>
                    <el-input type="text" v-model="searchData.GoodCode" class="search-item" size="small" style="width: 200px"></el-input>
                </div>
                <div class="flex">
                    <div class="search-name">适用车型</div>
                    <el-input v-model="searchData.AutoSerise" class="search-item" size="small" style="width: 194px"></el-input>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button class="search-btn btn-primary" size="small" @click="chooseAPs()">确定 (选中{{ selection.length }}项)</el-button>
                </div>
            </div>
        </div>
        <div class="dialogtable-ctn">
            <el-table
                v-loading="tableLoading"
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                height="420px"
                style="width: 100%; margin-bottom: 10px"
                @selection-change="onColumnSelect"
                @sort-change="sortChange"
                @row-click="rowClick"
                @cell-dblclick="dblChooseAps"
                highlight-current-row
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="150" prop="APCode" sortable="custom" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="GoodCode" label="互换码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100" prop="GoodName" label="汽配名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="AutoSerise" label="适用车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="60px" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Inventory" label="库存"> </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="CostPrice" label="最新在订价"> </el-table-column>
                <!-- <el-table-column
          show-overflow-tooltip
          min-width="80"
          prop="IntenCount"
          label="在订总数"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="80"
          prop="Count"
          label="已采总数"
        ></el-table-column> -->
                <el-table-column show-overflow-tooltip min-width="80" label="在订数">
                    <template slot-scope="scope">{{ scope.row.IntenCount - scope.row.Count }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Brand" label="汽配品牌"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Cate" label="汽配分类"></el-table-column>
                <el-table-column fixed="right" label="在订明细" width="80">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="查看" size="mini" type="text" @click="showHistoryDialog(scope.row.EntpTempGoodsId)">查看</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50, 200]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="加入清单"
            :visible.sync="rowVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            custom-class="add-row-dialog"
            style="margin-left: -170px"
        >
            <div class="form-div">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input-number :min="1" :precision="0" controls-position="right" v-model="rowForm._count" />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input-number :min="0" :precision="2" controls-position="right" v-model="rowForm._price" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" @click="rowConfirm">提交</el-button>
                <el-button size="small" @click="rowClose">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="在订历史"
            :visible.sync="historyVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-inq-dialog"
            style="margin-left: -500px"
        >
            <div v-if="historyVisible">
                <APInquiryHistory ref="APInquiryHistory" :EntpCusId="EntpCusId" :EntpTempGoodsId="goodsId" @closeDialog="closeHistoryDialog"></APInquiryHistory>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APInquiryHistory from '@/components/common/APInquiryHistory';
export default {
    name: '',
    props: ['EntpCusId'],
    components: { APInquiryHistory },
    data() {
        return {
            tableLoading: false,
            loading: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            dialogVisible: false,
            goodsId: '',
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                AutoSerise: '',
                Brand: '',
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 15,
                CusId: this.EntpCusId,
                SortProp: '',
                SortType: ''
            },
            tableData: [],
            tableDataLength: 0,
            selection: [],
            rowVisible: false,
            rowForm: {},
            historyVisible: false
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        // 单击一行，更新所有弹框内容
        rowClick(row) {
            if (this.historyVisible) {
                this.$refs.APInquiryHistory.updateTableData(row.EntpTempGoodsId);
            }
            if (this.rowVisible) {
                this.dblChooseAps(row);
            }
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            if ([e][0]) {
                let _price = e.CostPrice;
                this.rowVisible = true;
                this.rowForm = {
                    ...[e][0],
                    _count: 1,
                    _price
                };
            } else {
                this.$emit('closeDialog', [e]);
            }
        },
        rowConfirm() {
            this.$emit('closeDialog', [this.rowForm], true);
            this.rowVisible = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.rowForm = {};
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                AutoSerise: '',
                Brand: '',
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 15,
                CusId: this.EntpCusId,
                SortProp: '',
                SortType: ''
            };
        },
        getTableData() {
            this.tableLoading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpIntentPartList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        let data = res.data;
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                })
                .catch(e => {})
                .finally(() => {
                    this.tableLoading = false;
                });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = 1;
            this.searchData.page = val;
            this.getTableData();
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        showHistoryDialog(goodsId) {
            if (goodsId) {
                this.goodsId = goodsId;
                this.historyVisible = true;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    height: 600px;
    overflow-y: auto;
}
</style>
<style lang="less">
.dialogtable-ctn {
    .el-table {
        .el-table__body {
            .current-row {
                > td {
                    background-color: #bbddff;
                }
            }
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }
                td,
                th {
                    padding: 8px 0;
                }
            }
        }
    }
}
#change-inq-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 800px;
        height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        overflow: auto;
    }
}
</style>
